import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef } from 'vue';

import BrandIcon from '@/components/icons/BrandIcon.vue';
import { AppName } from '@/data/Branding';
import { usePushNotificationStore } from '@/stores/PushNotification';

interface Props {
  showClose?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PushNotificationPermissionBanner',
  props: {
    showClose: { type: Boolean, default: true }
  },
  setup(__props: any) {

const pushNotificationStore = usePushNotificationStore();



const message: ComputedRef<string> = computed(() => {
  return `${AppName} needs your permission to enable notifications on this device`;
});

function requestPushNotificationPermission(): void {
  pushNotificationStore.requestPushNotificationPermission();
}

function dismissBanner(): void {
  // Flag in local storage that the user dismissed the banner so we don't annoy them each time they reload
  pushNotificationStore.setBannerDismissed(true);
}

return { __sfc: true,pushNotificationStore, message, requestPushNotificationPermission, dismissBanner, BrandIcon }
}

})